// Scroll to Similar Styles section when clicking on similar icon
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    const similarIcon = event.target.closest('.product-card_similar_icon');

    if (similarIcon) {
      event.preventDefault();

      const targetSection = document.getElementById('similar-styles-list');

      if (targetSection) {
        // Get the element's position relative to the document
        const elementPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
        // Offset to account for fixed headers (adjust if needed)
        const offsetPosition = elementPosition - 80;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  });
});

